// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider, setPersistence, browserLocalPersistence } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAtlLSzOQnQZRc1ipbMEsiqsKA7USR4Ro4",
  authDomain: "moratadeo-f566e.firebaseapp.com",
  projectId: "moratadeo-f566e",
  storageBucket: "moratadeo-f566e.firebasestorage.app",
  messagingSenderId: "77082364886",
  appId: "1:77082364886:web:3146fb64228c40d35fb277",
  measurementId: "G-ZKJ887Y8LG"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);
const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);

// Explicitly force persistent login sessions
setPersistence(auth, browserLocalPersistence).catch(console.error);

const googleProvider = new GoogleAuthProvider();

export { app, analytics, db, storage, auth, googleProvider };
